// Hiding the on-screen keyboard (Android back / hide button) leaves the text field focused.
// renderShell() rebuilds the DOM on every live event and re-focuses the replacement field,
// which re-opens the keyboard the user just dismissed. Blurring the field once the visual
// viewport grows back by roughly a keyboard height makes that dismissal stick.
// Smaller changes (e.g. the browser address bar collapsing) stay below the threshold.
export const keyboardCloseThreshold = 120;

type Viewport = { readonly height: number; addEventListener(type: 'resize', listener: () => void): void };
type Blurrable = { blur(): void; matches(selector: string): boolean };

export function blurOnKeyboardClose(viewport: Viewport, focused: () => Blurrable | null, touch: () => boolean): void {
  let previous = viewport.height;
  viewport.addEventListener('resize', () => {
    const grown = viewport.height - previous;
    previous = viewport.height;
    if (grown < keyboardCloseThreshold || !touch()) return;
    const field = focused();
    if (field?.matches('textarea, input, [contenteditable="true"]')) field.blur();
  });
}

// Virtual Enter commonly has no physical code. Do not treat a narrow viewport or
// touch support alone as a virtual keyboard: tablets can have hardware keyboards.
export function isSoftEnter(event: Pick<KeyboardEvent, 'key' | 'code' | 'ctrlKey' | 'metaKey'>, touch: boolean): boolean {
  return touch && event.key === 'Enter' && !event.code && !event.ctrlKey && !event.metaKey;
}
